// DOI detail fields read the current revision's quality map while the record
// is on screen. `item.Revisions[item.RevisionID]` throws
// `reading 'undefined'` when Revisions is missing and RevisionID is too:
// the bracket is applied to undefined, and the missing id stringifies to
// the property name "undefined".

export function doiRevisionQuality(item) {
    const revisions = item?.Revisions;
    if (revisions == null) return undefined;
    return revisions[item?.RevisionID]?.Quality;
}

export function canRevise(item) {
    const revisions = item?.Revisions;
    if (revisions == null) return false;
    return Object.values(revisions[item?.RevisionID]?.Quality || {}).every((entry) => entry?.Completed);
}
